<template>
  <div>
    <ul class="menu">
      <li class="menu-item" v-for="(item, index) in data" :key="index" :class="{'active':currentMenuId==item.id}"
          @click="menuClick(item,index)" @mouseenter="showSubMenu(index)" @mouseleave="hideSubMenu(index)">
        <span>{{item.name}}</span>
        <img class="m-l-5" v-show="item.children" src="../../assets/img/header/arrow.png">
        <div v-if="item.children" class="nav-item-container" :class="{'visible': visibleSubMenus[index]}">
          <nav-item v-for="(citem, cindex) in item.children" :key="cindex" :data="citem" :layer="1" 
                    :index="getGlobalIndex(index, cindex)"
                    :parentData="item"
                    :TypeLists="TypeLists"
                    :CaseLists="CaseLists"
                    @pageSkip="pageSkip(item.id,item.path)"></nav-item>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import NavItem from "./NavItem";
import {
  getTypeList,
  getProductServiceTypeList
} from "../../network/v2revision";
  export default {
    name: "NavMenu",
    components: {NavItem},
    props: {
      data: Array,
    },
    watch: {
      data(newVal, oldVal) {
        this.currentMenuId = this.getMenuIdByPath(newVal, this.$store.state.currentPath);
      }
    },
    created() {
  
      this.calculateGlobalIndices();
      // 添加滚动事件监听
      window.addEventListener('scroll', this.handleScroll);
      this.getTypeList();
      this.getProductServiceTypeList();
     console.log("导航菜单数据",this.data);
    },
    destroyed() {
      // 组件销毁时移除事件监听
      window.removeEventListener('scroll', this.handleScroll);
    },
    data() {
      return {
        CaseLists: [],
         TypeLists:[],
         parentId: 0,
        currentMenuIndex: 0,
        currentMenuId: Number,
        globalIndices: [],
        visibleSubMenus: {}
      };
    },
    methods: {
      getProductServiceTypeList() {
      getProductServiceTypeList(this.parentId).then((res) => {
        this.CaseLists = res.data;
        console.log("父级CaseLists类型",this.CaseLists);
      });
    },
    getTypeList() {
      getTypeList(this.parentId).then((res) => {
        this.TypeLists = res.data || [];
        console.log("父级TypeLists类型",this.TypeLists);
      });
    },
      menuClick(route, index) {
        this.currentMenuIndex = index;
        if (route.path) {
          if (this.$router.currentRoute.path !== route.path) {
            if (route.path.indexOf("http") != -1) {
              window.open(route.path, "_blank");
            }
            else {
              this.$router.push({path: route.path});
              this.currentMenuId = route.id;
              this.saveState(route.path);
            }
          }
        }
      },
      pageSkip(id, path) {
        this.currentMenuId = id;
        this.saveState(path);
      },
      saveState(id) {
        this.$store.commit('updateCurrentPath', id);
      },
      getMenuIdByPath(data, path) {
        if (!data) {
          return -1;
        }
        for (let route of data) {
          if (route.path === path) {
            return route.id;
          }
          if (route.children && this.isChildPath(route.children, path)) {
            return route.id;
          }
        }
        return -1;
      },
      isChildPath(children, path) {
        return children.some((route) => {
          if (route.path === path) {
            return true;
          }
          return route.children && this.isChildPath(route.children, path);
        });
      },
      calculateGlobalIndices() {
        let globalIndex = 0;
        this.globalIndices = [];
        for (let item of this.data) {
          if (item.children) {
            const indices = [];
            for (let i = 0; i < item.children.length; i++) {
              indices.push(globalIndex);
              globalIndex++;
            }
            this.globalIndices.push(indices);
          } else {
            this.globalIndices.push([]);
          }
        }
      },
      getGlobalIndex(parentIndex, childIndex) {
        return this.globalIndices[parentIndex][childIndex];
      },
      // 显示子菜单
      showSubMenu(index) {
        this.$set(this.visibleSubMenus, index, true);
      },
      // 隐藏子菜单
      hideSubMenu(index) {
        this.$set(this.visibleSubMenus, index, false);
      },
      // 处理页面滚动事件
      handleScroll() {
        // 当页面滚动时，隐藏所有子菜单
        for (let key in this.visibleSubMenus) {
          this.$set(this.visibleSubMenus, key, false);
        }
      }
    },
    watch: {
      data: {
        handler() {
          this.calculateGlobalIndices();
        },
        deep: true
      }
    }
  }
</script>

<style>
  .menu-item {
    position: relative;
  }

  .pc-box .menu-item .nav-item-container {
    display: flex;
    /* justify-content: center; */
    flex-wrap: wrap;
    position: fixed;
    top: 65px;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    height: auto;
    background: #fff;
    height: auto;
    min-height: 200px;
    /* 默认隐藏 */
    visibility: hidden;
    opacity: 0;
    transition: opacity .3s ease, visibility .3s ease;
  }

  .pc-box .menu {
    cursor: pointer;
    text-align: center;
  }

  .pc-box .menu-item {
    /* line-height: 43px; */
    font-size: 16px;
    color: white;
    display: inline-block;
    margin-left: 20px;
    letter-spacing: 1px;
    padding: 10px 25px;
  }

  .pc-box .menu-item:hover > span {
    /* font-weight: bold; */
  }

  .pc-box .menu-item > img {
    margin: auto 0;
    display: inline-block;
    position: absolute;
    transform: translate(-50%, -50%);
    right: 0px;
    top: 50%;
  }

  /* 修改为通过visible类控制显示 */
  .pc-box .menu-item .nav-item-container.visible {
    opacity: 1;
    visibility: visible;
    transition: opacity .3s ease, visibility .3s ease;
    width: 100%;
  }

  .pc-box .nav-item-container {
    padding: 40px 0;
    color: hsla(0, 0%, 100%, .8);
    font-size: 15px;
    text-align: center;
    width: 100%;
    color: rgba(0, 0, 0, .5);
  }

  .pc-box .active {
    background: url("../../assets/img/header/under_line.png");
    background-repeat: no-repeat;
    background-position: center 40px;
  }

  .pc-box .menu .menu-item:hover {
    background-image: url("../../assets/img/header/under_line.png");
    background-repeat: no-repeat;
    background-position: center 40px;

  }
  .pc-box .menu .menu-item:hover > img {
    transform: rotate(-180deg);
    transform-origin: 3px 3px;
    transition: transform .3s ease;
    opacity: 1;
    display: inline-block;
  }

  .rotate180 {
    transform: rotate(-180deg);
    transition: transform .3s ease;
    opacity: 1;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/components/NavMenu/NavMenu.vue